import React, { useEffect } from "react";
import { Box, Modal } from "@mui/material";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./VirtualAccount.module.css";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import InfoIcon from "../../Assets/Images/Common/info-circle.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Dot from "../../Components/Icons/Dot";
import { getVirtualAccountStatus } from "../../Services/Login";
import { useState } from "react";
import { dismissLoader, presentLoader } from "../../Services/loader";
import VirtualAccountConsentGate from "../PaymentConsent/VirtualAccountConsentGate";
import { useCrm2Va, VaClosedBanner, VaUsedFor } from "../../Components/Home/Crm2/VaBanner";

const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.2rem",
		top: "1.2rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const VirtualAccount = ({ open, handleClose, loggedInUser }) => {
	const classes = useStyles();
	function closeModal() {
		handleClose();
	}
	const [virtualAccStatuses, setVirtualAccStatuses] = useState("");
	const crm2Va = useCrm2Va(); // M6-F8: CRM 2.0 texts only for a customer with a CRM 2.0 booking

	useEffect(() => {
		if (loggedInUser?.virtualAccId) {
			getVirtualAccStatus(loggedInUser?.virtualAccId);
		}
	}, [loggedInUser]);

	async function getVirtualAccStatus(AccId) {
		presentLoader();
		await getVirtualAccountStatus(AccId)
			.then((resp) => {
				console.log(resp);
				setVirtualAccStatuses(resp?.data?.status);
				dismissLoader();
			})
			.catch((err) => {
				console.error("could-not-fetch-details", err);
				dismissLoader();
			});
	}

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div className={cssClasses.virtualStatus}>
						Virtual Account Details
						{virtualAccStatuses === "closed" ? (
							<>
								<LeadStatusChip
									label={"Closed"}
									icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
									style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
								></LeadStatusChip>
								<div>
									<img
										data-tooltip-id={"closed"}
										src={InfoIcon}
										aria-label={"closed"}
										alt="info"
										style={{
											verticalAlign: "middle",
											marginLeft: 4,
											cursor: "pointer",
										}}
									/>
									<ReactTooltip
										style={{
											fontFamily: "Inter-Regular",
											fontSize: "1.4rem",
											overflow: "auto",
											cursor: "pointer",
										}}
										content={"Any funds transferred to this account will be refunded, as the account is currently closed."}
										id={"closed"}
									/>
								</div>
							</>
						) : virtualAccStatuses ? (
							<LeadStatusChip
								label={virtualAccStatuses}
								icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
								style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
							></LeadStatusChip>
						) : (
							""
						)}
					</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					{/* CRM 2.0 (DC-96): a closed account shows only the red banner, never the account details */}
					{crm2Va?.hasCrm2 && virtualAccStatuses === "closed" ? (
						<VaClosedBanner />
					) : (
					<VirtualAccountConsentGate>
					<div className={cssClasses.priceBreakDown}>
						<div className={cssClasses.price}>
							<span className={cssClasses.priceText}>Bank Account Number</span>
							<span className={cssClasses.priceText}>{loggedInUser?.virtualAccDetails?.bankAccountNumber}</span>
						</div>
						<div className={cssClasses.price}>
							<span className={cssClasses.priceText}>Bank IFSC Code </span>
							<span className={cssClasses.priceText}>{loggedInUser?.virtualAccDetails?.bankIFSCCode}</span>
						</div>
						{/* <div className={cssClasses.price}>
							<span className={cssClasses.priceText}>Bank UpiID </span>
							<span className={cssClasses.priceText}>{loggedInUser?.virtualAccDetails?.bankUpiId}</span>
						</div> */}
						<div className={cssClasses.price}>
							<span className={cssClasses.priceText}>bank Beneficiary Name</span>
							<span className={cssClasses.priceText}>{loggedInUser?.virtualAccDetails?.bankBeneficiaryName}</span>
						</div>
					</div>
					<VaUsedFor va={crm2Va} />
					</VirtualAccountConsentGate>
					)}
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#fff",
								backgroundColor: "#1570EF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Close"}
							clicked={() => {
								closeModal();
							}}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default VirtualAccount;
